export default __webpack_public_path__ + "db1685f52487dce2c5d08863ea437d95.png";